import { Subject } from "rxjs";
export var agreementSubject = new Subject();
export var homeSlides = [];
export var homeSliderSubject = new Subject();
export var notifications = [];
export var newsSubject = new Subject();
export var updateTicketSubject = new Subject();
export var updateOrderSubject = new Subject();
export var underServiceSubject = new Subject();
